import { motion } from "framer-motion";
import { ArrowUpRight, Trophy, Flag } from "lucide-react";
import { Reveal, StaggerGroup, StaggerItem } from "@/components/Reveal";
import { LENOX } from "@/data/site";

export const LenoxSection = () => {
  return (
    <section data-testid="lenox-section" className="relative overflow-hidden bg-[#050505] py-24 md:py-32">
      <div className="checker-texture absolute inset-0 opacity-[0.25]" />
      {/* big background accent word */}
      <span className="pointer-events-none absolute -right-6 top-8 select-none font-anton text-[22vw] leading-none text-white/[0.03] md:text-[16vw]">
        529
      </span>

      <div className="relative mx-auto grid max-w-[1400px] items-center gap-14 px-5 md:grid-cols-2 md:px-10">
        {/* Image collage */}
        <Reveal>
          <div className="relative">
            <div className="overflow-hidden rounded-xl border border-white/10">
              <img src={LENOX.heroImg} alt={`${LENOX.name} helmet`} className="aspect-[4/3] w-full object-cover" />
            </div>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="absolute -bottom-8 -right-4 w-2/3 overflow-hidden rounded-xl border-4 border-[#050505] shadow-2xl sm:w-1/2"
            >
              <img src={LENOX.actionImg} alt={`${LENOX.name} racing`} className="aspect-[16/10] w-full object-cover" />
            </motion.div>
            <div className="absolute left-4 top-4 flex items-center gap-2 rounded-full bg-kbyellow px-4 py-1.5 font-display text-sm tracking-wide text-black">
              <Flag className="h-4 w-4" /> TEAM BAHAMAS
            </div>
          </div>
        </Reveal>

        {/* Text */}
        <div className="mt-10 md:mt-0">
          <div className="mb-3 flex items-center gap-3">
            <span className="h-[2px] w-10 bg-kbyellow" />
            <span className="font-display text-base tracking-[0.3em] text-kbcyan">FLYING THE FLAG</span>
          </div>
          <h2 className="font-display text-5xl leading-[0.9] tracking-tight text-white md:text-7xl">
            Lenox <span className="text-kbcyan">Lockhart</span>
          </h2>
          <p className="mt-5 max-w-xl text-lg font-medium leading-relaxed text-white/80">{LENOX.lead}</p>
          {LENOX.bio.map((p, i) => (
            <p key={i} className="mt-4 max-w-xl leading-relaxed text-white/55">{p}</p>
          ))}

          <StaggerGroup className="mt-8 grid grid-cols-2 gap-4">
            {LENOX.achievements.map((a) => (
              <StaggerItem key={a.l}>
                <div className="rounded-xl border border-white/10 bg-obsidian p-4">
                  <div className="flex items-center gap-2">
                    <Trophy className="h-4 w-4 text-kbyellow" />
                    <span className="font-anton text-3xl leading-none text-white">{a.v}</span>
                  </div>
                  <p className="mt-2 text-xs uppercase tracking-wide text-white/50">{a.l}</p>
                </div>
              </StaggerItem>
            ))}
          </StaggerGroup>

          <a
            href={LENOX.website}
            target="_blank"
            rel="noreferrer"
            data-testid="lenox-website-btn"
            className="group mt-9 inline-flex items-center gap-2 rounded-xl bg-kbcyan px-7 py-4 font-display text-2xl tracking-wide text-black transition-transform hover:scale-[1.03]"
          >
            Visit lenoxlockhart.com
            <ArrowUpRight className="h-5 w-5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default LenoxSection;
